function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module link/linkimageui
 */
import { ButtonView } from 'ckeditor5/src/ui';
import { Plugin } from 'ckeditor5/src/core';
import LinkUI from './linkui';
import LinkEditing from './linkediting';
import { LINK_KEYSTROKE } from './utils';
import linkIcon from '../theme/icons/link.svg';
/**
 * The link image UI plugin.
 *
 * This plugin provides the `'linkImage'` button that can be displayed in the {@link module:image/imagetoolbar~ImageToolbar}.
 * It can be used to wrap images in links.
 *
 * @extends module:core/plugin~Plugin
 */

var LinkImageUI = /*#__PURE__*/function (_Plugin) {
  _inherits(LinkImageUI, _Plugin);

  var _super = _createSuper(LinkImageUI);

  function LinkImageUI() {
    _classCallCheck(this, LinkImageUI);

    return _super.apply(this, arguments);
  }

  _createClass(LinkImageUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var viewDocument = editor.editing.view.document;
      this.listenTo(viewDocument, 'click', function (evt, data) {
        if (_this._isSelectedLinkedImage(editor.model.document.selection)) {
          // Prevent browser navigation when clicking a linked image.
          data.preventDefault(); // Block the `LinkUI` plugin when an image was clicked.
          // In such a case, we'd like to display the image toolbar.

          evt.stop();
        }
      }, {
        priority: 'high'
      });

      this._createToolbarLinkImageButton();
    }
    /**
     * Creates a `LinkImageUI` button view.
     *
     * Clicking this button shows a {@link module:link/linkui~LinkUI#_balloon} attached to the selection.
     * When an image is already linked, the view shows {@link module:link/linkui~LinkUI#actionsView} or
     * {@link module:link/linkui~LinkUI#formView} if it is not.
     *
     * @private
     */

  }, {
    key: "_createToolbarLinkImageButton",
    value: function _createToolbarLinkImageButton() {
      var _this2 = this;

      var editor = this.editor;
      var t = editor.t;
      editor.ui.componentFactory.add('linkImage', function (locale) {
        var button = new ButtonView(locale);
        var plugin = editor.plugins.get('LinkUI');
        var linkCommand = editor.commands.get('link');
        button.set({
          isEnabled: true,
          label: t('Link image'),
          icon: linkIcon,
          keystroke: LINK_KEYSTROKE,
          tooltip: true,
          isToggleable: true
        }); // Bind button to the command.

        button.bind('isEnabled').to(linkCommand, 'isEnabled');
        button.bind('isOn').to(linkCommand, 'value', function (value) {
          return !!value;
        }); // Show the actionsView or formView (both from LinkUI) on button click depending on whether the image is linked already.

        _this2.listenTo(button, 'execute', function () {
          if (_this2._isSelectedLinkedImage(editor.model.document.selection)) {
            plugin._addActionsView();
          } else {
            plugin._showUI(true);
          }
        });

        return button;
      });
    }
    /**
     * Returns true if a linked image (either block or inline) is the only selected element
     * in the model document.
     *
     * @private
     * @param {module:engine/model/selection~Selection} selection
     * @returns {Boolean}
     */

  }, {
    key: "_isSelectedLinkedImage",
    value: function _isSelectedLinkedImage(selection) {
      var selectedModelElement = selection.getSelectedElement();
      var imageUtils = this.editor.plugins.get('ImageUtils');
      return imageUtils.isImage(selectedModelElement) && selectedModelElement.hasAttribute('linkHref');
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [LinkEditing, LinkUI, 'ImageBlockEditing'];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'LinkImageUI';
    }
  }]);

  return LinkImageUI;
}(Plugin);

export { LinkImageUI as default };